import React, { useEffect, useState } from 'react';
import { FullscreenModal } from '../../../common/fullscreenModal/FullscreenModal';
import {
  ButtonPrimary,
  DataTable,
  Loader,
  ModalContent,
  ModalHeader,
  //IconTrash,
  SelectInputSearch,
  Checkbox,
  Input,
  IconTrash,
} from '@skf/bt-wind-rail-commonlibrary';
import { useTranslation } from 'react-i18next';
import style from './TurbineManagementFormulary.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  TaxonomyCustomerAdmin,
  TaxonomyCustomerBrand,
  TaxonomySystemInfoAdminCompleted,
  TaxonomySystemInfoAdmin,
} from '../../../../store/taxonomy/types';
import { StoreState } from '../../../../store/store';
import { ITaxonomyState } from '../../../../store/taxonomy/store';
import {
  fetchAssets,
  GetBrandTaxonomyCustomer,
  PostAddNewTurbine,
  PostUpdateTurbine,
} from '../../../../store/taxonomy/actions';
import { IOption } from '@skf/bt-wind-rail-commonlibrary/dist/components/form/types';
import { useToast } from '../../../../hooks/useToast';
import CreateGUID from '../../../../utils/guid';

interface ITurbineManagementFormularyProps {
  taxonomy?: TaxonomySystemInfoAdmin;
  turbineOptions?: IOption[];
  turbines?: TaxonomySystemInfoAdminCompleted[];
  windfarms?: TaxonomyCustomerAdmin[];
  onClose: () => void;
  assets?: TaxonomySystemInfoAdminCompleted[];
}

export const TurbineManagementFormularyTurbine: React.FunctionComponent<ITurbineManagementFormularyProps> = ({
  taxonomy,
  turbines,
  turbineOptions,
  windfarms,
  onClose,
}) => {
  const [isFetching] = useState<boolean>(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { addToast } = useToast();
  const { taxonomyBrand } = useSelector<StoreState, ITaxonomyState>(
    (selector) => selector.taxonomyBrand
  );
  const [_taxonomyBrand, _setTaxonomyBrand] = useState<TaxonomyCustomerBrand[]>(
    []
  );

  // Options for Selectors Formulary
  const [_brandOptions, _setBrandOptions] = useState<IOption[]>([]);
  const [_modelOptions, _setModelOptions] = useState<IOption[]>([]);
  const [_windfarmsOptions, _setWindfarmsOptions] = useState<IOption[]>([]);

  // Formulary fields
  const [plantKey, setPlantKey] = useState<string>('');
  const [_systemID, _setSystemID] = useState<string>('');
  const [_systemDesc, _setSystemDesc] = useState<string>('');
  const [_systemBrand, _setSystemBrand] = useState<string>('');
  const [_systemModel, _setsystemModel] = useState<string>('');
  const [_capacity, _setCapacity] = useState<string>('');
  const [_systemContributionMargin, _setSystemContributionMargin] = useState<
    string
  >('');
  const [_latitude, _setLatitude] = useState<number>();
  const [_longitude, _setLongitude] = useState<number>();
  const [_commisioning, _setCommisioning] = useState<string>('');
  const [_autoSID, _setAutoSID] = useState<boolean>(false);
  const [_newModel, _setNewModel] = useState<boolean>(false);
  const [_newBrand, _setNewBrand] = useState<boolean>(false);
  

  // Formulary error field
  const [_errorWindfarm, _setErrorWindfarm] = useState<boolean>(false);
  const [_errorSystemID, _setErrorSystemID] = useState<boolean>(false);
  const [_errorSystemDescription, _setErrorSystemDescription] = useState<
    boolean
  >(false);
  const [_errorSystemBrand, _setErrorSystemBrand] = useState<boolean>(false);
  const [_errorSystemModel, _setErrorSystemModel] = useState<boolean>(false);
  //const [_errorCapacity, _setErrorCapacity] = useState<boolean>(false);
  const [_errorCommisioning, _setErrorCommisioning] = useState<boolean>(false);

  // list turbines to add
  const [_newTurbines, _setNewTurbines] = useState<TaxonomySystemInfoAdmin[]>(
    []
  );
  const [_turbineCopy, _setTurbineCopy] = useState<TaxonomySystemInfoAdmin>();

  const { taxonomyAssets } = useSelector<StoreState, ITaxonomyState>(
    (selector) => selector.taxonomy
  );

  //VALIDATION
  const borderOk = { border: `1px solid #c7cad0` };
  const borderError = {
    border: `1px solid red`,
    borderColor: `red !important`,
  };
  const [_latValidation, _setLatValidation] = useState(borderOk);
  const [_longValidation, _setLongValidation] = useState(borderOk);

  const [_saveButtonDisabled, _setSaveButtonDisabled] = useState(true);

  useEffect(() => {
    getAllWindFarms();
  }, []);

  useEffect(() => {
    _newTurbines && _newTurbines.length > 0
      ? _setSaveButtonDisabled(false)
      : _setSaveButtonDisabled(true);
    if (taxonomy) {
      _setSaveButtonDisabled(false);
    }
  }, [_newTurbines]);
  useEffect(() => {
    if (taxonomyBrand) {
      _setTaxonomyBrand(taxonomyBrand);
      addBrandOptions(taxonomyBrand);
      return;
    }

    dispatch(GetBrandTaxonomyCustomer());
  }, [taxonomyBrand]);

  useEffect(() => {
    if (taxonomy && _brandOptions.length > 0) {
      loadTurbine(taxonomy);
    }
  }, [_brandOptions, taxonomy]);

  function changeBrand(event: string) {
    if (!event) return;
    const filterTaxonomyModel: IOption[] = [];
    _taxonomyBrand.map((e: TaxonomyCustomerBrand) => {
      if (e.systemBrand && event === e.systemBrand) {
        filterTaxonomyModel.push({
          label: e.systemModel,
          value: e.systemModel,
          labelToShow: e.systemModel,
        });
      }
    });
    if (event) _setSystemBrand(event?.toString());
    _setModelOptions(filterTaxonomyModel);
  }

  function addBrandOptions(taxonomyBrandE: TaxonomyCustomerBrand[]) {
    const filterTaxonomyBrand: IOption[] = [];
    taxonomyBrandE.map((e: TaxonomyCustomerBrand) => {
      if (
        e.systemBrand &&
        !filterTaxonomyBrand.find((e2: IOption) => e2.value === e.systemBrand)
      ) {
        filterTaxonomyBrand.push({
          label: e.systemBrand,
          value: e.systemBrand,
          labelToShow: e.systemBrand,
        });
      }
    });
    _setBrandOptions(filterTaxonomyBrand);
  }

  function getAllWindFarms() {
    if (!windfarms) return;

    const filtertWindfarms: IOption[] = [];
    windfarms.map((e: TaxonomyCustomerAdmin) => {
      if (
        e.plantUnitId &&
        !filtertWindfarms.find((e2: IOption) => e2.value === e.plantUnitKey)
      ) {
        if (e?.plantUnitDescription && e?.plantUnitDescription)
          filtertWindfarms.push({
            label: e?.plantUnitDescription,
            value: e.plantUnitKey,
            labelToShow: e?.plantUnitDescription,
          });
      }

      _setWindfarmsOptions(filtertWindfarms);
    });
  }

  useEffect(() => {
    if (plantKey) _setErrorWindfarm(false);
    if (_systemID) _setErrorSystemID(false);
    if (_systemDesc) _setErrorSystemDescription(false);
    if (_systemBrand) _setErrorSystemBrand(false);
    if (_systemModel) _setErrorSystemModel(false);
    if (_commisioning) _setErrorCommisioning(false);
    if (_latitude) _setLatValidation(borderOk);
    if (_longitude) _setLongValidation(borderOk);
  }, [
    plantKey,
    _systemID,
    _systemDesc,
    _systemBrand,
    _systemModel,
    _commisioning,
    _latitude,
    _longitude,
  ]);

  function validateFormulary() {
    let toReturn = true;
    if (!plantKey) {
      _setErrorWindfarm(true);
      toReturn = false;
    }
    if (!_autoSID && !_systemID) {
      _setErrorSystemID(true);
      toReturn = false;
    }
    if (!_systemDesc) {
      _setErrorSystemDescription(true);
      toReturn = false;
    }
    if (!_systemBrand) {
      _setErrorSystemBrand(true);
      toReturn = false;
    }
    if (!_systemModel) {
      _setErrorSystemModel(true);
      toReturn = false;
    }

    if (!_commisioning) {
      _setErrorCommisioning(true);
      toReturn = false;
    }
    if (!_latitude) {
      _setLatValidation(borderError);
      toReturn = false;
    } else {
      _setLatValidation(borderOk);
    }
    if (!_longitude) {
      _setLongValidation(borderError);
      toReturn = false;
    } else {
      _setLongValidation(borderOk);
    }
    return toReturn;
  }

  function selectTurbineDuplicate(event: IOption | void) {
    if (event) {
      _setTurbineCopy(
        turbines?.find(
          (e: TaxonomySystemInfoAdmin) => e.sectionSystemId === event.value
        )
      );
      setPlantKey('');
    }
  }

  function setSystemDesc(value: string) {
    _setSystemDesc(value);

    if (_autoSID) {
      // console.log('taxonomy?.taxonomyAssetLocations',taxonomy?.taxonomyAssetLocations);
      // let count = 1;
      // if (
      //   taxonomy?.taxonomyAssetLocations.length &&
      //   taxonomy?.taxonomyAssetLocations.length > 1
      // )
      //   count = taxonomy?.taxonomyAssetLocations.length + 1;
      //_setSystemID(_plantID + '_' + value + count);
    }
  }

  function CreateSID(): string {
    let toReturn = '';

    if (_autoSID) {
      const windfarmPUK = windfarms?.find((x) => x.plantUnitKey === plantKey);
      if (windfarmPUK) {
        const turbs = windfarmPUK.taxonomySystemInfos.map(
          (x) => x.sectionSystemId
        );
        if (turbs) {
          let l = turbs.length;
          let ll = _newTurbines.length;

          toReturn = windfarmPUK.plantUnitId + '_Turb' + (l + ll + 1);
        } else {
          if (_newTurbines && _newTurbines.length > 0) {
            toReturn =
              windfarmPUK.plantUnitId + '_Turb' + (_newTurbines.length + 1);
          } else {
            toReturn = windfarmPUK.plantUnitId + '_Turb1';
          }
        }
      }
    } else {
      toReturn = _systemID;
    }
    return toReturn;
  }

  function addNewTurbine() {
    const systemID = CreateSID();
    if (_autoSID) {
      _setSystemID(systemID);
    }

    if (!validateFormulary()) {
      addToast({
        status: 'warning',
        message: t('Complete al required inputs'),
      });
      return;
    }

    if (!_commisioning || !_latitude || !_longitude) return;
    const windfarmPUK = windfarms?.find((x) => x.plantUnitKey === plantKey);

    if (windfarmPUK) {
      const turbineR = windfarmPUK.taxonomySystemInfos.find(
        (x) => x.sectionSystemId === _systemID
      );
      if (turbineR) {
        addToast({
          status: 'warning',
          message: t('Turbine_id_repeted'),
        });
        return;
      }
    }
    if (
      _newTurbines.find(
        (e: TaxonomySystemInfoAdmin) => e.sectionSystemId === systemID
      )
    ) {
      addToast({
        status: 'warning',
        message: t('Turbine_id_repeted'),
      });
      return;
    }

    // const auxWindfarm = windfarms?.find(
    //   (e: TaxonomyCustomerAdmin) => e.plantUnitKey === _plantID
    // );
    //const plantUnitId = auxWindfarm?.plantUnitId;
    //const numTurbines = auxWindfarm?.taxonomySystemInfos.length;

    const newTurbine: TaxonomySystemInfoAdmin = {
      sectionSystemId: systemID,
      sectionSystemKey: CreateGUID(),
      sectionSystemDescription: _systemDesc,
      sectionSystemCapacity: _capacity,
      sectionSystemContributionMargin: _systemContributionMargin,
      plantUnitDescription: windfarmPUK?.plantUnitDescription,
      plantUnitKey: plantKey,
      systemProperty1: '',
      systemProperty2: '',
      systemSequenceCode: '',
      systemInfoStatus: '',
      systemBrand: _systemBrand,
      systemModel: _systemModel,
      taxonomyAssetLocations: [],
      commissioningDate: _commisioning,
      longitude: _longitude,
      latitude: _latitude,
      isNewBrandOrModel: _newBrand || _newModel ? 1 : 0
    };

    _setNewTurbines([..._newTurbines, newTurbine]);
  }

  // function deleteNewTurbine(sectionSystemId: string) {
  //   const newTurbines = _newTurbines.filter(
  //     (e: TaxonomySystemInfoAdmin) => e.sectionSystemId !== sectionSystemId
  //   );
  //   _setNewTurbines(newTurbines);
  //   addToast({
  //     status: 'ok',
  //     message: t('Turbine_deleted'),
  //   });
  // }

  function loadTurbine(turbineToLoad: TaxonomySystemInfoAdmin | undefined) {
    if (!turbineToLoad) return;
    if (windfarms) _setSystemID(turbineToLoad.sectionSystemId);
    _setSystemDesc(turbineToLoad.sectionSystemDescription);
    _setCapacity(turbineToLoad.sectionSystemCapacity);
    _setSystemContributionMargin(turbineToLoad.sectionSystemContributionMargin);
    const theWindfarm = windfarms?.find(
      (x) => x.plantUnitKey == turbineToLoad.plantUnitKey
    );
    if (theWindfarm) {
      setPlantKey(theWindfarm.plantUnitKey || '');
    } else {
      setPlantKey(turbineToLoad.plantUnitKey);
    }

    _setsystemModel(turbineToLoad.systemModel);
    changeBrand(turbineToLoad.systemBrand);
    const d = new Date(turbineToLoad.commissioningDate);
    const year = d.getFullYear();
    let month = d.getMonth().toString();
    if (Number(month) < 10) month = '0' + month;
    let day = d.getDate().toString();
    if (Number(day) < 10) day = '0' + day;
    _setCommisioning(year + '-' + month + '-' + day);
    _setLatitude(turbineToLoad.latitude);
    _setLongitude(turbineToLoad.longitude);
  }

  function handlerPostAddNewTurbine() {
    const addTurbineOkToast = () => {
      addToast({
        status: 'ok',
        message: t('addTurbineOk'),
        timeout: 7000,
      });
    };
    const addTurbineOkToastProgress = () => {
      addToast({
        status: 'warning',
        message: t('addTurbine'),
        timeout: 7000,
      });
    };
    const addTurbineErrorToast = () => {
      addToast({
        status: 'danger',
        message: t('failedAddTurbine'),
        timeout: 7000,
      });
    };
    dispatch(
      PostAddNewTurbine(
        _newTurbines,
        addTurbineOkToast,
        addTurbineOkToastProgress,
        addTurbineErrorToast
      )
    );
    onClose();
  }
  function handlerUpdateTurbine() {
    if (!validateFormulary()) {
      addToast({
        status: 'warning',
        message: t('Complete al required inputs'),
      });
      return;
    }
    if (!taxonomy) return;
    const turbineToUpdate: TaxonomySystemInfoAdmin = taxonomy;
    turbineToUpdate.sectionSystemId = _systemID;
    turbineToUpdate.sectionSystemKey = taxonomy.sectionSystemKey;
    turbineToUpdate.sectionSystemDescription = _systemDesc;
    turbineToUpdate.sectionSystemCapacity = _capacity;
    turbineToUpdate.sectionSystemContributionMargin = _systemContributionMargin;
    turbineToUpdate.plantUnitKey = taxonomy.plantUnitKey;
    turbineToUpdate.systemModel = _systemModel;
    turbineToUpdate.systemBrand = _systemBrand;
    turbineToUpdate.commissioningDate = _commisioning;
    if (_latitude) turbineToUpdate.latitude = _latitude;
    if (_longitude) turbineToUpdate.longitude = _longitude;
    turbineToUpdate.isNewBrandOrModel = _newBrand || _newModel ? 1 : 0

    const toastrTurbineId = turbineToUpdate.sectionSystemId || '';
    const updateTurbineErrorToast = () => {
      addToast({
        status: 'danger',
        message: t('failedUpdateTurbine').replace('@', toastrTurbineId),
        timeout: 7000,
      });
    };

    const updateTurbineOkToast = () => {
      addToast({
        status: 'ok',
        message: t('modifyTurbineOk'),
        timeout: 7000,
      });
    };

    const updateTurbineProgressToast = () => {
      addToast({
        status: 'warning',
        message: t('modifyTurbine').replace('@', toastrTurbineId),
        timeout: 7000,
      });
    };

    dispatch(
      PostUpdateTurbine(
        [turbineToUpdate],
        updateTurbineOkToast,
        updateTurbineProgressToast,
        updateTurbineErrorToast
      )
    );
    onClose();
  }

  const columnsTurbine: any[] = [
    {
      Header: t('WindFarm'),
      accessor: 'plantUnitDescription',
    },
    {
      Header: t('System_ID'),
      accessor: 'sectionSystemId',
    },
    {
      Header: t('System Descriptions'),
      accessor: 'sectionSystemDescription',
    },
    {
      Header: t('System Brand'),
      accessor: 'systemBrand',
    },
    {
      Header: t('System Model'),
      accessor: 'systemModel',
    },

    {
      Header: '',
      accessor: 'Action',
      disableSortBy: true,

      Cell: ({
        row: {
          original: { sectionSystemId },
        },
      }: any) => {
        return (
          <div>
            <IconTrash
              onClick={() => deleteNewTurbine(sectionSystemId)}
              className={style.cursorPointer}
            />
          </div>
        );
      },
    },
  ];
  const columnsAssets: any[] = [
    {
      Header: t('Section System ID'),
      accessor: 'sectionSystemId',
    },
    {
      Header: t('Asset Class Code'),
      accessor: 'assetClassCode',
    },
    {
      Header: t('Asset ID'),
      accessor: 'assetId',
    },
    {
      Header: t('Model'),
      accessor: 'manufacturerModel',
    },
    {
      Header: t('Name'),
      accessor: 'manufacturerName',
    },
  ];

  function deleteNewTurbine(sectionSystemId) {
    _setNewTurbines(
      _newTurbines.filter((x) => x.sectionSystemId !== sectionSystemId)
    );
  }

  //if taxonomy gave assets
  useEffect(() => {
    if (taxonomy) {
      dispatch(fetchAssets(taxonomy.plantUnitKey, taxonomy.sectionSystemKey));
    }
  }, []);

  let turbineOptionsConst: IOption[] = [];
  if (turbineOptions) turbineOptionsConst = turbineOptions;
  return (
    <FullscreenModal onClose={onClose} className={style.modal}>
      <ModalHeader onClose={onClose}>
        {!taxonomy
          ? t('Add_New_Turbine')
          : t('Modify') + ' ' + taxonomy?.sectionSystemId}
      </ModalHeader>
      <ModalContent className={style.content}>
        <>
          <Loader center show={isFetching} className={style.loader} />
          <div className={isFetching ? style.blur : ''}>
            <div className={style.containerTurbine}>
              {!taxonomy && (
                <div className={style.conatinerColumsClone}>
                  <SelectInputSearch
                    placeHolder={'Clone turbine'}
                    options={turbineOptionsConst}
                    onSelectedItemChanged={(e) => selectTurbineDuplicate(e)}
                  />
                  <ButtonPrimary
                    outline
                    onClick={() => {
                      loadTurbine(_turbineCopy);
                      _setSystemID('');
                    }}
                  >
                    {t('clone')}
                  </ButtonPrimary>
                </div>
              )}
              {!taxonomy && (
                <ButtonPrimary outline onClick={addNewTurbine}>
                  {t('add_turbine')}
                </ButtonPrimary>
              )}
              <SelectInputSearch
                value={plantKey}
                error={_errorWindfarm ? true : false}
                placeHolder={'Select WindFarm *'}
                options={_windfarmsOptions}
                onSelectedItemChanged={(e) => {
                  if (e) setPlantKey(e.value.toString());
                }}
              ></SelectInputSearch>
              <div>
                <Checkbox
                  square
                  isChecked={_autoSID}
                  onClick={() => _setAutoSID(!_autoSID)}
                />
                <label>{t('auto_SID')}</label>
              </div>
              <div className={style.conatinerthreColums}>
                <Input
                  disabled={_autoSID}
                  className={
                    _errorSystemID ? style.errorInput : style.correctInput
                  }
                  value={_autoSID ? 'AUTO' : _systemID}
                  placeholder={'System_ID *'}
                  maxLength={60}
                  onChange={(e) => _setSystemID(e)}
                />
                <Input
                  className={
                    _errorSystemDescription
                      ? style.errorInput
                      : style.correctInput
                  }
                  value={_systemDesc}
                  placeholder={'System Descriptions (Turbine Name) *'}
                  maxLength={60}
                  onChange={(e) => setSystemDesc(e)}
                />
                {_newBrand ? (
                  <Input
                    className={
                      _errorSystemBrand ? style.errorInput : style.correctInput
                    }
                    value={_systemBrand}
                    placeholder={'System Brand *'}
                    maxLength={40}
                    onChange={(e) => _setSystemBrand(e)}
                  />
                ) : (
                  <SelectInputSearch
                    error={_errorSystemBrand ? true : false}
                    value={_systemBrand}
                    placeHolder={'System Brand *'}
                    options={_brandOptions}
                    onSelectedItemChanged={(e) => {
                      if (e) changeBrand(e?.value.toString());
                      if (e == null) changeBrand('');
                    }}
                  />
                )}
              </div>
              <div>
                <Checkbox
                  square
                  isChecked={_newBrand}
                  onClick={() => {
                    _setNewBrand(!_newBrand);
                    if (!_newBrand === false) {
                      _setNewModel(false);
                      _setsystemModel('');
                    } else {
                      _setNewModel(true);
                      _setsystemModel('');
                    }
                  }}
                />
                <label>New Brand</label>
              </div>
              <div className={style.conatinerthreColums}>
                {_newModel || _newBrand ? (
                  <Input
                    className={
                      _errorSystemModel ? style.errorInput : style.correctInput
                    }
                    value={_systemModel}
                    placeholder={'System Model *'}
                    maxLength={600}
                    onChange={(e) => _setsystemModel(e)}
                  />
                ) : (
                  <SelectInputSearch
                    error={_errorSystemModel ? true : false}
                    value={_systemModel}
                    placeHolder={'System Model *'}
                    options={_modelOptions}
                    onSelectedItemChanged={(e) => {
                      if (e) _setsystemModel(e?.value.toString());
                      if (e == null) _setsystemModel('');
                    }}
                  />
                )}

                <Input
                  value={_capacity}
                  type={'number'}
                  placeholder={'Capacity (Turbine MW)'}
                  maxLength={31}
                  onChange={(e) => _setCapacity(e)}
                />
                <Input
                  value={_systemContributionMargin}
                  type={'number'}
                  placeholder={'System contribution margin'}
                  maxLength={31}
                  onChange={(e) => _setSystemContributionMargin(e)}
                />
              </div>
              <div>
                <Checkbox
                  square
                  isChecked={_newModel}
                  onClick={() => _setNewModel(!_newModel)}
                />
                <label>New Model</label>
              </div>
              <div className={style.conatinerthreColums}>
                <Input
                  style={_latValidation}
                  value={_latitude}
                  maxLength={31}
                  type={'number'}
                  placeholder={'Latitude'}
                  onChange={(e) => _setLatitude(Number(e))}
                />
                <Input
                  style={_longValidation}
                  value={_longitude}
                  type={'number'}
                  placeholder={'Longitude'}
                  maxLength={31}
                  onChange={(e) => _setLongitude(Number(e))}
                />
                <Input
                  className={
                    _errorCommisioning ? style.errorInput : style.correctInput
                  }
                  value={_commisioning}
                  type={'date'}
                  placeholder={'Commisioning Date'}
                  onChange={(e) => {
                    _setCommisioning(e);
                  }}
                />
              </div>
            </div>
            <DataTable
              columns={taxonomy ? columnsAssets : columnsTurbine}
              data={taxonomy && taxonomyAssets ? taxonomyAssets : _newTurbines}
              className={style.table}
              pagination={20}
            />

            <div className={style.navigation}>
              <ButtonPrimary onClick={onClose} outline>
                {t('Cancel')}
              </ButtonPrimary>
              <ButtonPrimary
                onClick={
                  taxonomy ? handlerUpdateTurbine : handlerPostAddNewTurbine
                }
                outline
                disabled={_saveButtonDisabled}
              >
                {t('Save')}
              </ButtonPrimary>
            </div>
          </div>
        </>
      </ModalContent>
    </FullscreenModal>
  );
};
